import styled from 'styled-components';

export const TimeLine = styled.ul`
  padding: 0;
  margin-left: 135px;
  padding-top: 20px;
`;

export const TimeLineItem = styled.li`
  list-style-type: none;
  padding: 1em;
  margin: 0;
  transition: background-color 0.5s;
  overflow: visible;
  border-left: 2px solid #eaeaea;
`;

export const TimeLineDate = styled.div`
  display: inline-block;
  float: left;
  margin-left: -110px;
  max-width: 100px;
  margin-top: 5px;

  & > b {
    display: block;
    font-size: 12px;
    font-weight: bold;
    text-align: right;
  }
  & > span {
    display: block;
    font-size: 11px;
    color: #888;
    text-align: right;
  }
`;

export const TimeLineIconContainer = styled.div`
  display: inline-block;
  float: left;
  width: 34px;
  height: 34px;
  line-height: 40px;
  border: 2px solid #eaeaea;
  border-radius: 50%;
  margin-left: -33px;
  background: #f7f8fa;

  &.in_progress i::before {
    content: '';

    height: 10px;
    width: 10px;

    border-radius: 100%;

    background: #eaeaea;
  }
  &.error {
    background: #f56c6c;
  }
  &.delivered {
    background: #67c23a;
  }
  &.out_off_delivery {
    background: #e6a23c;
  }

  & i {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    color: #fff;
  }
`;

export const InfoContainer = styled.div`
  margin-left: 15px;
  margin-top: 4px;
  font-size: 14px;
  text-align: left;
`;

export const Info = styled.div`
  display: flex;

  & > div > img {
    height: 12px;
    margin-right: 10px;
  }
`;

export const InfoStatus = styled.span`
  font-size: 12px;
  margin-right: 10px;
  font-weight: 700;
`;

export const InfoDescription = styled.div`
  font-size: 11px;
  color: #888;
  margin-left: 22px;
`;
